import { useMemo } from 'react';

import { dayOfWeekMapper } from '@ecp/common/src/const/good';

const useGoodSelectedRegularDelivery = (selectedRegularDelivery, hasTimeList) => {
  const { period, total, time, startDateTime } = selectedRegularDelivery;

  const selectedAll = useMemo(() => {
    return period?.code && total?.key && ((hasTimeList && time?.key) || !hasTimeList) && startDateTime;
  }, [hasTimeList, period?.code, startDateTime, time?.key, total?.key]);

  const deliveryInfo = useMemo(() => {
    return `${period?.name} 간격 / 총 ${total?.label} / ${hasTimeList ? time?.label + ' / ' : ''}${
      dayOfWeekMapper[startDateTime?.getDay()]
    }요일마다 배송`;
  }, [hasTimeList, period?.name, startDateTime, time?.label, total?.label]);

  const deliveryStateDateInfo = useMemo(() => {
    const month = (startDateTime?.getMonth() + 1).toString().padStart(2, '0');
    const day = startDateTime?.getDate().toString().padStart(2, '0');
    return `배송시작일 : ${startDateTime?.getFullYear()}년 ${month}월 ${day}일 (${
      dayOfWeekMapper[startDateTime?.getDay()]
    })`;
  }, [startDateTime]);

  return { selectedAll, deliveryInfo, deliveryStateDateInfo };
};

export default useGoodSelectedRegularDelivery;
